var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vHeader'),_c('router-view'),_c('vFooter'),_c('goTop'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer_service"},[_c('img',{attrs:{"src":require("@/assets/img/team/service.png")}}),_c('a',{attrs:{"target":"_blank","href":"https://tccc.qcloud.com/web/im/index.html#/chat?webAppId=65334cb6792c3182ffc70145dc68f8c4"}},[_vm._v(" 在线咨询 ")])])
}]

export { render, staticRenderFns }